const PRIMARY_COLOR = '#ADE3E3'
const SECONDARY_COLOR = '#02A9AB'
const LIGHT_RED = '#D87F7A'
export { PRIMARY_COLOR, SECONDARY_COLOR, LIGHT_RED }
